// extracted by mini-css-extract-plugin
module.exports = {"send_meal_modal":"CommonStore_index_send_meal_modal__yVXjp"};